import styles from "./Containers.module.css";

const AuditQuestionCard = ({ children, questionGUID, inputGiven }) => {
  let divStyle = inputGiven
    ? styles.auditQuestionCard
    : styles.auditQuestionCardNoInput;

  return (
    <div
      key={questionGUID}
      name={questionGUID}
      id={questionGUID}
      className={divStyle}
    >
      {children}
    </div>
  );
};

export default AuditQuestionCard;
